// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-hidden-field',
    mixins: [appHost.mixins.form],
});
// #endregion
